// helpers
import axios from "./axios";
import API_ROUTES from "./routes.constant";


export default {
  pageView: () => axios.post("/user-engagement"),
  showResults: () => axios.post(API_ROUTES.analytics.showResults),
  dismissBanner: () => axios.post(API_ROUTES.analytics.dismissBanner),
  recordBannerClick: (data: Record<string, string>) => axios.post(API_ROUTES.analytics.bannerClick, data),
  amplificationBanner: (data: Record<string, string>) => axios.post(API_ROUTES.analytics.amplificationBanner, data),
  gettingStartedVideo: (data: Record<string, unknown>) => axios.post(API_ROUTES.analytics.gettingStartedVideo, data),
  recordSiteVisitRequest: (data: Record<string, unknown>) => axios.post(
    API_ROUTES.analytics.recordSiteVisitRequest, data
  ),
  advancedFilterRequest: (data: Record<string, unknown>) => axios.post(
    API_ROUTES.analytics.advancedFilter, data
  ),
  userEngagement: (data: Record<string, unknown>) => axios.post(API_ROUTES.analytics.userEngagement, data),
  virtualTourClick: (data: Record<string, unknown>) => axios.post(API_ROUTES.analytics.virtualTourClick, data),
};
